export default __webpack_public_path__ + "static/media/Carousel_1.4d5cf095.jpg";